export default "__VITE_ASSET__XjLa3Tlh__"